import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import './index.css';
import 'icheck/skins/all.css'; // or single skin css
import 'chartjs-plugin-datalabels';

import i18n from 'locales/i18n';
import configureStore from 'store/configureStore';
import reducers from 'store/reducers';

import { Routes } from 'routes';
import registerServiceWorker from './registerServiceWorker';

const store = configureStore(reducers);

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <Routes />
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// PROGRESSIVE WEB APP
registerServiceWorker();



// WEBPACK FOOTER //
// src/index.js